import React from 'react';
import {EmailTemplateContainer} from '../../Containers/EmailContainer';



const EmailTemplateView = (props) => {
	return (
		<EmailTemplateContainer page="view" />
	);
}

export default EmailTemplateView;